import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router';
import { useCompanyStore } from '@/stores/useCompanyStore';

/**
 * Fiche rattachée à une société (employé, équipe) : la société de la sidebar suit la fiche affichée ; en choisir
 * ensuite une autre ramène à listPath (la liste de cette autre société). companyId undefined : fiche pas encore chargée.
 */
export function useFollowEntityCompany(companyId: number | undefined, listPath: string) {
  const navigate = useNavigate();
  const currentCompanyId = useCompanyStore((state) => state.currentCompanyId);
  const companies = useCompanyStore((state) => state.companies);
  const companiesLoaded = useCompanyStore((state) => state.loaded);
  const selectCompany = useCompanyStore((state) => state.select);
  /** Société de la fiche une fois suivie par la sidebar */
  const shownCompanyId = useRef<number | null>(null);

  useEffect(() => {
    // Sociétés de la sidebar pas encore chargées (page ouverte directement) : rien à comparer
    if (!companyId || !companiesLoaded) return;
    if (currentCompanyId !== companyId && shownCompanyId.current === null) {
      if (companies.some((company) => company.id === companyId)) selectCompany(companyId);
      shownCompanyId.current = companyId;
      return;
    }
    if (currentCompanyId === companyId) {
      shownCompanyId.current = companyId;
    } else if (shownCompanyId.current === companyId && currentCompanyId !== null) {
      navigate(listPath);
    }
  }, [companyId, companiesLoaded, currentCompanyId, companies, selectCompany, navigate, listPath]);
}
